"use client";

import createSvgIcon from './utils/createSvgIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon( /*#__PURE__*/_jsx("path", {
  d: "M1.94 11.79c-.6.56-.94 1.35-.94 2.18V20c0 1.66 1.34 3 3 3h13.68c.65 0 1.25-.47 1.32-1.12.08-.75-.51-1.38-1.24-1.38H12.5c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h7.18c.65 0 1.25-.47 1.32-1.12.08-.75-.51-1.38-1.24-1.38H12.5c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h8.18c.65 0 1.25-.47 1.32-1.12.08-.75-.51-1.38-1.24-1.38H12.5c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h6.18c.65 0 1.25-.47 1.32-1.12.08-.75-.51-1.38-1.24-1.38h-9.9l1.49-2.61c.09-.16.14-.33.14-.53 0-.26-.09-.5-.26-.7l-.42-.45c-.38-.39-1.01-.41-1.41-.03zM18.5 8C19.88 8 21 6.88 21 5.5c0-1.25-1.41-3.16-2.11-4.04a.489.489 0 0 0-.77 0C17.41 2.34 16 4.25 16 5.5 16 6.88 17.12 8 18.5 8m-5 1c.83 0 1.5-.67 1.5-1.5 0-.56-.67-1.49-1.11-2.04-.2-.25-.58-.25-.77 0C12.67 6.01 12 6.94 12 7.5c0 .83.67 1.5 1.5 1.5"
}), 'WashRounded');


//////////////////
// WEBPACK FOOTER
// ./node_modules/@mui/icons-material/esm/WashRounded.js
// module id = 12702
// module chunks = 0